export default "__VITE_ASSET__CcDtFzMH__"